import { apiFetch } from "./apiClient";

export function listarPresupuestos() {
    return apiFetch("/api/presupuestos");
}

export function obtenerEjecucionPresupuesto() {
    return apiFetch("/api/presupuestos/ejecucion");
}

export function crearPresupuesto(payload) {
    return apiFetch("/api/presupuestos", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarPresupuesto(id, payload) {
    return apiFetch(`/api/presupuestos/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function eliminarPresupuesto(id) {
    return apiFetch(`/api/presupuestos/${id}`, {
        method: "DELETE",
    });
}